import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor() { }

  // Verifica si el navegador soporta la API de Notificaciones
  public isNotificationSupported(): boolean {
    return 'Notification' in window;
  }

  // Solicita permiso al usuario para mostrar notificaciones
  public requestPermission(): Promise<NotificationPermission> {
    return Notification.requestPermission();
  }

  // Muestra una notificación
  public showNotification(title: string, options?: NotificationOptions): void {
    if (!this.isNotificationSupported()) {
      console.error('Este navegador no soporta notificaciones.');
      return;
    }

    // Si el permiso ya está concedido, muestra la notificación
    if (Notification.permission === 'granted') {
      new Notification(title, options);
    } else if (Notification.permission !== 'denied') {
      // Solicita permiso y luego muestra la notificación si es concedido
      this.requestPermission().then(permission => {
        if (permission === 'granted') {
          new Notification(title, options);
        }
      });
    }
  }
}
